/**
 * @generated SignedSource<<c39d5b38381af083658c3a5fedae1664>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutWireTransferWrapper_item$data = {
  readonly dibsReference: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "CheckoutWireTransferWrapper_item";
};
export type CheckoutWireTransferWrapper_item$key = {
  readonly " $data"?: CheckoutWireTransferWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutWireTransferWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutWireTransferWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dibsReference",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f3dbb0aee33933f108b8f93b317e0711";

export default node;
